import { render, staticRenderFns } from "./addGiftCompany.vue?vue&type=template&id=9e5d4a42&lang=true"
import script from "./addGiftCompany.vue?vue&type=script&lang=js"
export * from "./addGiftCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports